import { Link } from 'react-router-dom'

function Performances() {
	return (
		<div className='min-h-screen py-12'>
			<div className='max-w-6xl mx-auto px-4'>
				<h1 className='text-5xl font-serif text-center mb-12'>Performances</h1>

				{/* Featured Performance */}
				<div className='mb-16'>
					<h2 className='text-3xl font-serif mb-6 text-center'>Featured Performances</h2>
					<div className='grid md:grid-cols-2 gap-8 max-w-6xl mx-auto'>
						<div className='bg-ivory rounded-lg shadow-xl overflow-hidden'>
							<div className='aspect-[9/16] w-full'>
								<video
									className='w-full h-full object-cover'
									src='https://cdn.shopify.com/videos/c/o/v/b602cab18c554f5da31e96b5d7950ff2.mp4'
									title="Comptine d'un autre été - Yann Tiersen"
									controls
									playsInline></video>
							</div>
							<div className='p-6'>
								<h3 className='text-2xl font-serif mb-2'>
									Experience - Ludovico Einaudi
								</h3>
								<p className='text-piano-black/70'>
									A heartfelt interpretation of one of Einaudi's most beloved
									pieces, performed at the Steigenberger Pure Life Hotel in
									Hurghada, Egypt.
								</p>
							</div>
						</div>

						<div className='bg-ivory rounded-lg shadow-xl overflow-hidden'>
							<div className='aspect-[9/16] w-full'>
								<video
									className='w-full h-full object-cover'
									src='https://cdn.shopify.com/videos/c/o/v/5acff5a0e298433192f838fb494250f6.mp4'
									title="Comptine d'un autre été - Yann Tiersen"
									controls
									playsInline></video>
							</div>
							<div className='p-6'>
								<h3 className='text-2xl font-serif mb-2'>
									Comptine d'un autre été - Yann Tiersen
								</h3>
								<p className='text-piano-black/70'>
									A delicate rendition of this beloved piece from the movie
									Amélie, performed at the Makadi Spa Hotel in Hurghada, Egypt.
								</p>
							</div>
						</div>

						<div className='bg-ivory rounded-lg shadow-xl overflow-hidden'>
							<div className='aspect-[9/16] w-full'>
								<video
									className='w-full h-full object-cover'
									src='https://cdn.shopify.com/videos/c/o/v/e453e58599934373b9ce484d96b9f543.mp4'
									title='Hans Zimmer - Gladiator'
									controls
									playsInline></video>
							</div>
							<div className='p-6'>
								<h3 className='text-2xl font-serif mb-2'>
									Hans Zimmer - Gladiator
								</h3>
								<p className='text-piano-black/70'>
									A powerful performance of Hans Zimmer's iconic score from the
									movie Gladiator, showcasing emotional depth and technical
									mastery.
								</p>
							</div>
						</div>

						<div className='bg-ivory rounded-lg shadow-xl overflow-hidden'>
							<div className='aspect-[9/16] w-full'>
								<video
									className='w-full h-full object-cover'
									src='https://cdn.shopify.com/videos/c/o/v/867b1dc893564c79a39879bfeda3143e.mp4'
									title='Hans Zimmer - Interstellar'
									controls
									playsInline></video>
							</div>
							<div className='p-6'>
								<h3 className='text-2xl font-serif mb-2'>
									Hans Zimmer - Interstellar
								</h3>
								<p className='text-piano-black/70'>
									A mesmerizing rendition of the haunting theme from Interstellar,
									capturing the vastness and mystery of space through music.
								</p>
							</div>
						</div>

						<div className='bg-ivory rounded-lg shadow-xl overflow-hidden'>
							<div className='aspect-[9/16] w-full'>
								<video
									className='w-full h-full object-cover'
									src='https://cdn.shopify.com/videos/c/o/v/7d6dbce41d584ff995d89554a4fe5440.mp4'
									title='Adele - Someone like You'
									controls
									playsInline></video>
							</div>
							<div className='p-6'>
								<h3 className='text-2xl font-serif mb-2'>
									Adele - Someone like You
								</h3>
								<p className='text-piano-black/70'>
									A soulful piano cover of Adele's hit "Someone like You"
								</p>
							</div>
						</div>

						{/* <div className='bg-ivory rounded-lg shadow-xl overflow-hidden'>
							<div className='aspect-[9/16] w-full'>
								<video
									className='w-full h-full object-cover'
									src='https://cdn.shopify.com/videos/c/o/v/7d6dbce41d584ff995d89554a4fe5440.mp4'
									title='Adele - Someone like You'
									controls
									playsInline></video>
							</div>
							<div className='p-6'>
								<h3 className='text-2xl font-serif mb-2'>
									Adele - Someone like You
								</h3>
								<p className='text-piano-black/70'>
									A soulful piano cover of Adele's hit "Someone like You"
								</p>
							</div>
						</div> */}
					</div>
				</div>

				{/* Booking Section */}
				<div className='mb-16'>
					<div className='max-w-4xl mx-auto bg-ivory p-8 rounded-lg shadow-lg'>
						<h2 className='text-3xl font-serif mb-6 text-center'>
							Available for Bookings
						</h2>
						<div className='grid md:grid-cols-2 gap-8'>
							<div className='space-y-4'>
								<h3 className='text-xl font-medium mb-2'>Private Events</h3>
								<ul className='space-y-2 text-piano-black/80'>
									<li className='flex items-start'>
										<span className='text-piano-black/40 mr-3'>•</span>
										<span>Luxury hotel performances</span>
									</li>
									<li className='flex items-start'>
										<span className='text-piano-black/40 mr-3'>•</span>
										<span>Corporate functions</span>
									</li>
									<li className='flex items-start'>
										<span className='text-piano-black/40 mr-3'>•</span>
										<span>Wedding ceremonies and receptions</span>
									</li>
									<li className='flex items-start'>
										<span className='text-piano-black/40 mr-3'>•</span>
										<span>Special celebrations</span>
									</li>
								</ul>
							</div>
							<div className='space-y-4'>
								<h3 className='text-xl font-medium mb-2'>Repertoire Highlights</h3>
								<ul className='space-y-2 text-piano-black/80'>
									<li className='flex items-start'>
										<span className='text-piano-black/40 mr-3'>•</span>
										<span>Classical masterpieces</span>
									</li>
									<li className='flex items-start'>
										<span className='text-piano-black/40 mr-3'>•</span>
										<span>Contemporary favorites</span>
									</li>
									<li className='flex items-start'>
										<span className='text-piano-black/40 mr-3'>•</span>
										<span>Jazz standards</span>
									</li>
									<li className='flex items-start'>
										<span className='text-piano-black/40 mr-3'>•</span>
										<span>Customized song selections</span>
									</li>
								</ul>
							</div>
						</div>
						<div className='mt-8 text-center'>
							<Link
								to='/contact'
								className='inline-block px-8 py-3 bg-piano-black text-ivory rounded-lg hover:bg-piano-black/90 transition-colors'>
								Inquire About Booking
							</Link>
						</div>
					</div>
				</div>
			</div>
		</div>
	)
}

export default Performances
